import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneClassroom from '../ones/OneClassroom';
import { MdCheck, MdDelete, MdSms, MdWhatsapp } from "react-icons/md";

export default function StreamRegistrationForm({ data, classroomUuid, createCallback, editCallback }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [name, setName] = useState("");
	const [supportedSubjects, setSupportedSubjects] = useState([]);


	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getAllSubjects(),

		])
		setReady(true);
	}

	function addSubject() {
		setSupportedSubjects(_prev => {
			const _new = [..._prev];

			_new.push("")

			return _new;
		})
	}

	function removeSubject(index) {
		setSupportedSubjects(_prev => {

			const _new = [..._prev];

			_new.splice(index, 1);

			return _new;

		})
	}

	function handleSubjectChange(index, value) {
		setSupportedSubjects(_prev => {
			const _new = [..._prev];

			_new[index] = value;

			return _new;
		})
	}

	function cleanSubjects(_subjects) {
		const _cleaned = [... new Set(_subjects.filter((item, i) => {
			if(String(item).trim().length > 0) {
				return true;
			} else {
				return false;
			}
		}))]

		return _cleaned;
	}

	function resetForm() {
		setName("");
		setSupportedSubjects([]);
	}

	async function create() {
		const _subjects = cleanSubjects(supportedSubjects);
		if(name.trim().length > 0) {
			setLoading(true);
			await callApi(
				'create-stream',
				{
					name,
					supportedSubjects: JSON.stringify(_subjects),
					classroomUuid,
					schoolUuid: appContext.currentSchoolUuid,
				}
			).then(response => {
				if(response.status === 1) {
					
					if(createCallback) {
						createCallback();
					}

					appContext.tellMessage("Successful");
					resetForm()
				} else {
					appContext.tellError(response.msg)
				}
			})
			setLoading(false);
		} else {
			appContext.tellError("Invalid name");
		}
	}

	async function edit() {
		const _subjects = cleanSubjects(supportedSubjects);
		if(name.trim().length > 0) {
			setLoading(true);
			await callApi(
				'edit-stream',
				{
					uuid: data.uuid,
					name,
					supportedSubjects: JSON.stringify(_subjects),
					schoolUuid: appContext.currentSchoolUuid,
					classroomUuid,
				}
			).then(response => {
				if(response.status === 1) {

					if(editCallback) {
						editCallback();
					}

					appContext.tellMessage("Successful");
				} else {
					appContext.tellError(response.msg)
				}
			})
			setLoading(false);
		} else {
			appContext.tellError("Invalid name");
		}
	}

	useEffect(() => {
		init();
	}, [])

	

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	useEffect(() => {
		if(data) {
			setName(data.name);
			setSupportedSubjects(JSON.parse(data.supportedSubjects));
		}
	}, [ data ])

	if (ready) {
		return (
		
			<div className="row">
				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Stream's Name</label>
					<input
						className="form-control"
						value={name}
						onChange={e => setName(e.target.value)}
					/>
				</div>

				
				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Allocated Subjects</label>
					{
						supportedSubjects.map((item, i) => {
							return (
								<div className="d-flex m-1" key={i}>
									<select
										className="form-control"
										
										style={{
											flexGrow: 1,
										}}
										onChange={(e) => handleSubjectChange(i, e.target.value)}
										value={item}
									>
										<option value="">Click to select subject</option>
										{
											appContext.allSubjects.map((item, i) => {
												return (
													<option key={i} value={item.uuid}>{item.name}</option>
												)
											})
										}
									</select>

									<MdDelete
										style={{
											flexShrink: 0,
											cursor: 'pointer'
										}}
										size={24}
										onClick={() => removeSubject(i)}
										className="text-danger"
									/>
								</div>
							)
						})
					}

					<div className="mt-2">
						<button
							className="btn btn-sm btn-outline-dark"
							onClick={addSubject}
						>
							Add Subject
						</button>
					</div>
				</div>
					

				<div className="col-md-12 mt-2 mb-2 text-end">
					{
						(data) ?
						<button
							className="btn btn-secondary"
							onClick={() => {
								appContext.activateDialog({
									message: `Edit strem information for ${name}?`,
									onConfirm: edit,
								})
							}}
						>
							<MdCheck/> Submit
						</button>
						:
						<button
							className="btn btn-secondary"
							onClick={() => {
								appContext.activateDialog({
									message: `Create new stream, ${name}?`,
									onConfirm: create,
								})
							}}
						>
							<MdCheck/> Submit
						</button>
					}
				</div>
			</div>
								
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}